import { Check } from "lucide-react";

export const ProgressChecklist = ({ items }) => {
  const done = items.filter((i) => i.done).length;
  const jump = (target) => document.querySelector(target)?.scrollIntoView({ behavior: "smooth", block: "center" });
  return (
    <div className="mt-6 border border-ink/15 bg-white p-6 sm:p-7" data-testid="progress-checklist">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <p className="overline text-ink/60">Your application</p>
        <p className="overline" data-testid="progress-count">
          <span className={done === items.length ? "text-emerald-600" : "text-gloss-gold"}>{done} of {items.length} done</span>
        </p>
      </div>
      <div className="flex h-1.5 gap-1 mb-6">
        {items.map((it, i) => (
          <span key={i} className={`flex-1 ${it.done ? "bg-gloss-gold" : "bg-ink/10"}`} />
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {items.map((it, i) => (
          <button
            key={i}
            type="button"
            onClick={() => jump(it.target)}
            className={`text-left border p-4 transition-colors ${it.done ? "border-gloss-gold/40 bg-gloss-gold/5" : "border-ink/15 hover:border-ink/40"}`}
            data-testid={`progress-item-${i}`}
          >
            <span className={`inline-flex items-center justify-center w-5 h-5 border mb-2.5 ${it.done ? "bg-gloss-gold border-gloss-gold text-ink" : "border-ink/30 text-transparent"}`}>
              <Check size={12} strokeWidth={3} />
            </span>
            <p className="font-sans text-sm font-medium">{it.label}</p>
            <p className="font-sans text-xs text-ink/50 mt-1">{it.done ? it.doneNote : it.todoNote}</p>
          </button>
        ))}
      </div>
      {done === items.length ? (
        <p className="font-sans text-sm text-emerald-700 mt-5" data-testid="progress-complete-note">All done — sit back, the editorial desk takes it from here.</p>
      ) : (
        <p className="font-sans text-xs text-ink/45 mt-5">Tap a step to jump straight to it. Anything you skip, the desk works around.</p>
      )}
    </div>
  );
};
